import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import Search from './Search';
import Notification from './Notification';
import Profile from './Profile';
import RoleBadge from './RoleBadge';
import MobileSection from './MobileSection';

export default function HeaderContent() {
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <>
      <Search />
      <Box sx={{ flexGrow: 1 }} />
      {!downMD ? (
        <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
          <Notification />
          <RoleBadge />
          <Profile />
        </Stack>
      ) : (
        <MobileSection />
      )}
    </>
  );
}
